import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { Typography } from "@mui/material";
import { InfoWindow } from "@vis.gl/react-google-maps";
import { formatTime } from "hhn-commons";
import React from "react";
import { PatientHeaderDescription } from "../../message/messageHeader/patientGroupHeader/PatientHeaderDescription";
import { GROUP_AVATAR_SIZE } from "../../utils/AvatarUtils";

function MarkerInfoWindow(props: {
  selectedLocation: any;
  onCloseClick: () => void;
}) {
  return (
    <InfoWindow
      position={{
        lat: props.selectedLocation.location.coordinates[1],
        lng: props.selectedLocation.location.coordinates[0],
      }}
      onCloseClick={props.onCloseClick}
      pixelOffset={[0, -36]}
    >
      <PatientHeaderDescription
        patientStatus={props.selectedLocation.patientStatus}
        name={props.selectedLocation.name}
        servicesToPatient={[]}
        fontSizeTitle={16}
        avatarSize={GROUP_AVATAR_SIZE.XSMALL}
      />
      <Typography
        variant="body2"
        sx={{
          mb: 1,
          display: "flex",
          alignItems: "center",
          gap: "5px",
          opacity: "0.7",
          marginTop: "5px",
          justifyContent: "center",
        }}
      >
        <AccessTimeIcon />
        {formatTime(props.selectedLocation.schedulerTime)} -{" "}
        {formatTime(props.selectedLocation.schedulerEndTime)}
      </Typography>
    </InfoWindow>
  );
}

export default MarkerInfoWindow;
